module.exports = __webpack_public_path__ + "img/sankaku_84_blue.6b524cb8.png";